import { render, staticRenderFns } from "./country.vue?vue&type=template&id=48b93b71&scoped=true"
import script from "./country.vue?vue&type=script&lang=js"
export * from "./country.vue?vue&type=script&lang=js"
import style0 from "./country.vue?vue&type=style&index=0&id=48b93b71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b93b71",
  null
  
)

export default component.exports